import type {ReactElement} from 'react';
import {SocialProfileIcon, SocialProfileIconSize} from '@Components/social-media/components/social-profile-icon';
import {Text, TextSize} from '@Components/text';
import {assertNever} from '@Utils/assert-never.util';
import type {PreviewAccountHeaderProps} from './preview-account-header.types';
import {PreviewAccountHeaderLayout} from './preview-account-header.types';
import styles from './preview-account-header.module.scss';

export function PreviewAccountHeader({account, className = '', identityClassName = '', layout = PreviewAccountHeaderLayout.STACKED, metaRow, trailingAction}: PreviewAccountHeaderProps): ReactElement {
  const getAccountNameTextSize = (): TextSize => {
    switch (layout) {
      case PreviewAccountHeaderLayout.STACKED:
        return TextSize.XS;
      case PreviewAccountHeaderLayout.INLINE:
        return TextSize.SM;
      default:
        return assertNever(layout);
    }
  };

  const getNameAndMetaLayoutClassName = (): string => {
    switch (layout) {
      case PreviewAccountHeaderLayout.STACKED:
        return '';
      case PreviewAccountHeaderLayout.INLINE:
        return styles.nameAndMetaInline;
      default:
        return assertNever(layout);
    }
  };

  return (
    <div className={`${styles.accountHeader} ${className}`}>
      <div className={`${styles.identity} ${identityClassName}`}>
        <SocialProfileIcon account={account} size={SocialProfileIconSize.MEDIUM} showPlatformIcon={false} showHoverOverlay={false} />
        <div className={`${styles.nameAndMeta} ${getNameAndMetaLayoutClassName()}`}>
          <Text val={account.name} size={getAccountNameTextSize()} bold className={styles.accountName} />
          {metaRow}
        </div>
      </div>
      {trailingAction}
    </div>
  );
}
